export const DIALOGUE_SYSTEM_TYPE = 'custom_dialogue_system'
export const LEGACY_DIALOGUE_SYSTEM_TYPE = 'dialogue_system'
